import { forwardRef, type ImgHTMLAttributes } from 'react';
import { cn } from '../utils/cn';

export interface ProfileAvatarProps extends ImgHTMLAttributes<HTMLImageElement> {
    /**
     * When the avatar is a fallback race portrait rather than an uploaded
     * photo. Portraits are full-body artwork with the head at the top edge,
     * so they align to the container's top; uploaded photos are square
     * headshots and centre naturally.
     */
    racePortrait?: boolean;
}

const BASE_CLASSES = 'w-32 h-32 rounded-full object-cover border border-space-700 shrink-0';

/**
 * The shared avatar-card shape used by `ProfilePage` and
 * `PlayerProfilePage` — a large round portrait with the fallback portrait
 * pinned to the top edge. Previously duplicated as the same literal Tailwind
 * string in both pages.
 */
export const ProfileAvatar = forwardRef<HTMLImageElement, ProfileAvatarProps>(function ProfileAvatar(
    { racePortrait = false, className, ...rest },
    ref,
) {
    return (
        <img
            ref={ref}
            className={cn(BASE_CLASSES, racePortrait && 'object-top', className)}
            {...rest}
        />
    );
});

export default ProfileAvatar;
